import PageScrollSmoother from "../PageScrollSmoother";
import SayHelloHero from "./SayHelloHero";
import SayHelloHeading from "./SayHelloHeading";
import SayHelloForm from "./SayHelloForm";
import HelpYouButton from "./HelpYouButton";

export default class SayHello {
  static instance;

  constructor() {
    if (SayHello.instance) {
      return SayHello.instance;
    }
    SayHello.instance = this;

    this.scrollSmoother = new PageScrollSmoother();
    this.sayHelloHero = new SayHelloHero();
    this.sayHelloHeading = new SayHelloHeading();
    this.form = new SayHelloForm();
    this.helpYouButton = new HelpYouButton();

    this.helpYouButton.setScroll(this.scrollSmoother);
  }
}
